import React, { useEffect, useState, useContext, useRef } from 'react';
import { Modal, Table,Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './Styles.css';

function GridEnergy({ SN, Combinations }) {
    const { t } = useTranslation();
    
    const [direct, setDirect] = useState("ToGrid");
    const [icon, setIcon] = useState("images/inverter/grid_export.png");
    const [title, setTitle] = useState(t('Feed-in Energy'));
    const [dayTitle, setDayTitle] = useState(t('Today Export'));
    const [totalTitle, setTotalTitle] = useState(t('Total Export'));

    useEffect(() => {
        if (direct === "FromGrid") {
            setIcon("images/inverter/grid_import.png");
            setTitle(t('Import Energy'));
            setDayTitle(t('Today Import'));
            setTotalTitle(t('Total Import'));
        } else {
            setIcon("images/inverter/grid_export.png");
            setTitle(t('Feed-in Energy'));
            setDayTitle(t('Today Export'));
            setTotalTitle(t('Total Export'));
        }
    })

    const handleClick = () => {
        if (direct === "ToGrid") {
            setDirect("FromGrid");
        } else {
            setDirect("ToGrid");
        }
    }


    const showDetails = (e) => {
        e.stopPropagation();

        Modal.info({
            maskClosable: true,
            width: "80%",
            icon: null,
            title: t("Grid Energy"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase == 2 ? "(A)" : r.Phase == 3 ? "(B)" : r.Phase == 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("Daily Feed-in/Import (kWh)"), dataIndex: "EDayToGrid",  align: "left", render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["EDayFromGrid"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            if (v2 > 0x7fffffff) {
                                v2 = v2 - 0x100000000;
                            }
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                    { title: t("Monthly Feed-in/Import (kWh)"), dataIndex: "EMonthToGrid",  align: "left", render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["EMonthFromGrid"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            if (v2 > 0x7fffffff) {
                                v2 = v2 - 0x100000000;
                            }
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                    { title: t("Yearly Feed-in/Import (kWh)"), dataIndex: "EYearToGrid",  align: "left", render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["EYearFromGrid"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            if (v2 > 0x7fffffff) {
                                v2 = v2 - 0x100000000;
                            }
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                    { title: t("Total Feed-in/Import (kWh)"), dataIndex: "ETotalToGrid",  align: "left", render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["ETotalFromGrid"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            if (v2 > 0x7fffffff) {
                                v2 = v2 - 0x100000000;
                            }
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                ]}
                summary={(data) => {
                    if (!data || data.length < 2) {
                        return null;
                    }
                    let EDayToGrid = 0;
                    let EDayFromGrid = 0;
                    let EMonthToGrid = 0;
                    let EMonthFromGrid = 0;
                    let EYearToGrid = 0;
                    let EYearFromGrid = 0;
                    let ETotalToGrid = 0;
                    let ETotalFromGrid = 0;
                    data.forEach((item, index) => {
                        if (item.EDayToGrid != null ) {
                            let v = parseInt(item.EDayToGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDayToGrid += v * 0.01;
                        }
                        if (item.EDayFromGrid != null ) {
                            let v = parseInt(item.EDayFromGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDayFromGrid += v * 0.01;
                        }
                        if (item.EMonthToGrid != null ) {
                            let v = parseInt(item.EMonthToGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthToGrid += v * 0.01;
                        }
                        if (item.EMonthFromGrid != null ) {
                            let v = parseInt(item.EMonthFromGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthFromGrid += v * 0.01;
                        }
                        if (item.EYearToGrid != null ) {
                            let v = parseInt(item.EYearToGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearToGrid += v * 0.01;
                        }
                        if (item.EYearFromGrid != null ) {
                            let v = parseInt(item.EYearFromGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearFromGrid += v * 0.01;
                        }
                        if (item.ETotalToGrid != null ) {
                            let v = parseInt(item.ETotalToGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalToGrid += v * 0.01;
                        }
                        if (item.ETotalFromGrid != null ) {
                            let v = parseInt(item.ETotalFromGrid);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalFromGrid += v * 0.01;
                        }
                    });
                    return (
                        <>
                            <Table.Summary.Row style={{fontWeight:"bold"}}>
                                <Table.Summary.Cell index={0} colSpan={2} align='right'>{t("Subtotal")}</Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>{EDayToGrid.toFixed(2)} / {EDayFromGrid.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{EMonthToGrid.toFixed(2)} / {EMonthFromGrid.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{EYearToGrid.toFixed(2)} / {EYearFromGrid.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{ETotalToGrid.toFixed(2)} / {ETotalFromGrid.toFixed(2)}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
                dataSource={Combinations}
                scroll={{ x: true }}
            />),
            onOk() {
            },
        });
    };

    let EDay = 0;
    let ETotal = 0;
    let count = Combinations?.length || 0;

    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            if (item[`EDay${direct}`] != null ) {
                let v = parseInt(item[`EDay${direct}`]);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                EDay += v * 0.01;
            }
            if (item[`ETotal${direct}`] != null ) {
                let v = parseInt(item[`ETotal${direct}`]);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                ETotal += v * 0.01;
            }
        });
    }
    

    return (<div className="combination-stats-block" style={{cursor: "pointer"}} onClick={handleClick}>
        <div className="title" style={{ backgroundColor: '#92b5c9' }}>
            {title}
            <Button ghost size='small' shape="round" onClick={showDetails}>{t("Details")}</Button>
        </div>
        <div className="content" >
            <div className="left">
                <img src={icon} alt={t('Grid Energy')}></img>
            </div>
            <div className="right">
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {EDay.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{dayTitle}</div>
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {ETotal.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{totalTitle}</div>
            </div>
        </div>
    </div>);
}

export default GridEnergy;